export const ar: Record<string, string> = {
  // Sidebar
  "nav.home": "الرئيسية",
  "nav.assistant": "المساعد القانوني",
  "nav.legalMemo": "صياغة المذكرات",
  "nav.documentAnalysis": "تحليل المستندات",
  "nav.smartSearch": "البحث الذكي",
  "nav.contractAnalysis": "تحليل العقود",
  "nav.analysisHub": "تحليل الوثائق",
  "analysisHub.title": "تحليل الوثائق والعقود",
  "analysisHub.subtitle": "تحليل المستندات القانونية والعقود بالذكاء الاصطناعي",
  "analysisHub.documentsTab": "تحليل المستندات",
  "analysisHub.contractsTab": "تحليل العقود",
  "nav.smartInterrogation": "الاستجواب الذكي",
  "nav.calendar": "التقويم",
  "nav.sessions": "الجلسات",
  "nav.clients": "الموكلين",
  "nav.tasks": "المهام",
  "nav.teamTasks": "توزيع المهام",
  "nav.teamPerformance": "أداء الفريق",
  "nav.files": "الملفات",
  "nav.announcements": "التنبيهات",
  "nav.cases": "القضايا",
  "nav.records": "أجندة محضرين",
  "nav.archive": "الأرشيف",
  "nav.notifications": "الإشعارات",
  "nav.finances": "المالية وتتبع الوقت",
  "nav.clientIntake": "استقبال العملاء",
  "nav.report": "تقرير النظام",
  "nav.subscribedOffices": "المكاتب المشتركة",
  "nav.backup": "النسخ الاحتياطي",
  "nav.caseRoll": "رول القضايا",
  "sidebar.system": "نظام إدارة المحاماة",
  "sidebar.changePassword": "تغيير كلمة المرور",
  "sidebar.newPassword": "كلمة المرور الجديدة",
  "sidebar.confirmPassword": "تأكيد كلمة المرور",
  "sidebar.enterNewPassword": "أدخل كلمة المرور الجديدة",
  "sidebar.reenterPassword": "أعد إدخال كلمة المرور",
  "sidebar.updating": "جاري التحديث...",
  "sidebar.updatePassword": "تحديث كلمة المرور",
  "sidebar.ai": "الذكاء الاصطناعي",
  "sidebar.management": "إدارة المكتب",
  "sidebar.more": "المزيد",

  // Common
  "common.add": "إضافة",
  "common.edit": "تعديل",
  "common.delete": "حذف",
  "common.save": "حفظ",
  "common.cancel": "إلغاء",
  "common.search": "بحث",
  "common.loading": "جاري التحميل...",
  "common.noData": "لا توجد بيانات",
  "common.error": "خطأ",
  "common.success": "تم بنجاح",
  "common.copy": "نسخ",
  "common.download": "تحميل",
  "common.copied": "تم النسخ",
  "common.close": "إغلاق",
  "common.confirm": "تأكيد",
  "common.back": "رجوع",
  "common.next": "التالي",
  "common.previous": "السابق",
  "common.all": "الكل",
  "common.active": "نشط",
  "common.inactive": "غير نشط",
  "common.now": "الآن",
  "common.view": "عرض",
  "common.print": "طباعة",
  "common.export": "تصدير",

  // Dashboard
  "dashboard.title": "لوحة التحكم",
  "dashboard.welcome": "مرحباً بك في Legal AI",
  "dashboard.activeCases": "الدعاوى النشطة",
  "dashboard.clients": "الموكلين",
  "dashboard.pendingTasks": "المهام المعلقة",
  "dashboard.files": "الملفات",
  "dashboard.upcomingEvents": "المواعيد القادمة",
  "dashboard.noUpcomingEvents": "لا توجد مواعيد قادمة",
  "dashboard.addEventsFromCalendar": "أضف مواعيدك من صفحة التقويم",
  "dashboard.latestNotifications": "آخر الإشعارات",
  "dashboard.noNotifications": "لا توجد إشعارات",
  "dashboard.enableNotifications": "تفعيل الإشعارات الفورية",
  "dashboard.enableNotificationsDesc": "احصل على تنبيهات تلقائية قبل مواعيد الجلسات",
  "dashboard.enable": "تفعيل",
  "dashboard.notificationsEnabled": "الإشعارات مفعّلة - ستصلك تنبيهات قبل مواعيد الجلسات",
  "dashboard.pendingTasksNotif": "مهام معلقة",
  "dashboard.upcomingAppointments": "مواعيد قادمة",
  "dashboard.activeCasesNotif": "قضايا نشطة",

  // Cases
  "cases.title": "الدعاوى",
  "cases.subtitle": "إدارة ومتابعة القضايا",
  "cases.newCase": "دعوى جديدة",
  "cases.editCase": "تعديل الدعوى",
  "cases.addCase": "إضافة دعوى جديدة",
  "cases.caseNumber": "رقم القضية",
  "cases.caseTitle": "موضوع القضية",
  "cases.selectClient": "اختر الموكل",
  "cases.caseType": "نوع القضية",
  "cases.court": "المحكمة",
  "cases.clientDetails": "تفاصيل الموكل (ستظهر للموكل)",
  "cases.status.active": "جارية",
  "cases.status.pending": "معلقة",
  "cases.status.closed": "منتهية",
  "cases.assignToMember": "إسناد لعضو فريق (اختياري)",
  "cases.saveChanges": "حفظ التعديلات",
  "cases.searchPlaceholder": "بحث برقم القضية أو اسم الموكل...",
  "cases.noCases": "لا توجد دعاوى",
  "cases.noCasesHint": "اضغط على \"دعوى جديدة\" لإضافة قضية",
  "cases.documents": "المستندات",
  "cases.prediction": "تنبؤ النتائج",
  "cases.caseNumberLabel": "رقم القضية:",

  // Sessions
  "sessions.title": "الجلسات",
  "sessions.subtitle": "تتبع جميع جلسات المحاكم مع التنبيهات",
  "sessions.addSession": "إضافة جلسة",
  "sessions.editSession": "تعديل الجلسة",
  "sessions.addNewSession": "إضافة جلسة جديدة",
  "sessions.upcoming": "الجلسات القادمة",
  "sessions.past": "الجلسات السابقة",
  "sessions.noUpcoming": "لا توجد جلسات قادمة",
  "sessions.caseNumber": "رقم الدعوى",
  "sessions.caseTitle": "عنوان الدعوى",
  "sessions.court": "المحكمة",
  "sessions.selectCourt": "اختر المحكمة",
  "sessions.roomNumber": "رقم الدائرة",
  "sessions.sessionDate": "تاريخ الجلسة",
  "sessions.selectDate": "اختر التاريخ",
  "sessions.sessionTime": "وقت الجلسة",
  "sessions.reminderBefore": "التذكير قبل (أيام)",
  "sessions.notes": "ملاحظات",
  "sessions.additionalNotes": "أي ملاحظات إضافية...",
  "sessions.ended": "منتهية",
  "sessions.today": "اليوم",
  "sessions.tomorrow": "غداً",
  "sessions.daysLeft": "بعد {days} أيام",
  "sessions.oneDay": "يوم واحد",
  "sessions.twoDays": "يومين",
  "sessions.threeDays": "3 أيام",
  "sessions.oneWeek": "أسبوع",
  "sessions.other": "أخرى",
  "sessions.enterCourtName": "أدخل اسم المحكمة",
  "sessions.roomExample": "مثال: الدائرة 5",
  "sessions.morning": "صباحي",
  "sessions.evening": "مسائي",
  "sessions.selectTime": "اختر وقت الجلسة",
  "sessions.number": "رقم:",

  // Clients
  "clients.title": "الموكلين",
  "clients.subtitle": "إدارة بيانات الموكلين",
  "clients.addClient": "إضافة موكل",
  "clients.addNewClient": "إضافة موكل جديد",
  "clients.clientName": "اسم الموكل",
  "clients.phone": "رقم الهاتف",
  "clients.email": "البريد الإلكتروني",
  "clients.casesCount": "عدد القضايا",
  "clients.searchPlaceholder": "بحث بالاسم أو رقم الهاتف...",
  "clients.noClients": "لا يوجد موكلون",
  "clients.noClientsHint": "اضغط على \"إضافة موكل\" لإضافة موكل جديد",
  "clients.viewProfile": "عرض ملف الموكل",

  // Tasks
  "tasks.title": "المهام",
  "tasks.subtitle": "إدارة ومتابعة المهام اليومية",
  "tasks.addTask": "إضافة مهمة",
  "tasks.editTask": "تعديل المهمة",
  "tasks.addNewTask": "إضافة مهمة جديدة",
  "tasks.taskTitle": "عنوان المهمة",
  "tasks.taskDescription": "وصف المهمة",
  "tasks.dueDate": "تاريخ الاستحقاق",
  "tasks.caseNumber": "رقم القضية (اختياري)",
  "tasks.priority": "الأولوية",
  "tasks.priority.high": "عاجل",
  "tasks.priority.medium": "متوسط",
  "tasks.priority.low": "عادي",
  "tasks.pending": "مهام معلقة",
  "tasks.urgent": "مهام عاجلة",
  "tasks.completed": "مهام مكتملة",
  "tasks.pendingTasks": "المهام المعلقة",
  "tasks.completedTasks": "المهام المكتملة",
  "tasks.noPending": "لا توجد مهام معلقة",
  "tasks.noCompleted": "لا توجد مهام مكتملة",

  // Calendar
  "calendar.title": "التقويم",
  "calendar.subtitle": "إدارة المواعيد والجلسات",
  "calendar.addEvent": "إضافة موعد",
  "calendar.addNewEvent": "إضافة موعد جديد",
  "calendar.eventTitle": "عنوان الموعد",
  "calendar.eventTime": "الوقت (مثال: 10:00 ص)",
  "calendar.eventType": "نوع الموعد",
  "calendar.selectedDate": "التاريخ المحدد:",
  "calendar.type.court": "جلسة محكمة",
  "calendar.type.meeting": "اجتماع",
  "calendar.type.task": "مهمة",
  "calendar.eventsFor": "مواعيد",
  "calendar.noEvents": "لا توجد مواعيد لهذا اليوم",
  "calendar.noEventsHint": "اضغط على \"إضافة موعد\" لإضافة موعد جديد",
  "calendar.typeLabels.court": "جلسة",
  "calendar.typeLabels.meeting": "اجتماع",
  "calendar.typeLabels.task": "مهمة",

  // Files
  "files.title": "الملفات",
  "files.subtitle": "إدارة وتنظيم الملفات والمستندات",
  "files.upload": "رفع ملف",
  "files.uploading": "جاري الرفع...",
  "files.searchPlaceholder": "بحث في الملفات...",
  "files.allFiles": "الملفات",
  "files.noFiles": "لا توجد ملفات",
  "files.noFilesHint": "اضغط على \"رفع ملف\" لإضافة ملفات",

  // Announcements
  "announcements.title": "التنبيهات",
  "announcements.subtitle": "آخر التنبيهات والإشعارات",
  "announcements.newAnnouncement": "تنبيه جديد",
  "announcements.addNew": "إضافة إعلان جديد",
  "announcements.announcementTitle": "عنوان الإعلان",
  "announcements.announcementContent": "محتوى الإعلان",
  "announcements.pinAnnouncement": "تثبيت الإعلان",
  "announcements.noAnnouncements": "لا توجد إعلانات",
  "announcements.noAnnouncementsHint": "اضغط على \"إعلان جديد\" لإضافة إعلان",
  "announcements.author": "المحامي",

  // Records (أجندة محضرين)
  "records.title": "أجندة محضرين",
  "records.subtitle": "إدارة وتنظيم مهام المحضرين والإعلانات القضائية",
  "records.newRecord": "إضافة بند جديد",
  "records.addNew": "إضافة بند جديد للأجندة",
  "records.recordTitle": "موضوع الإعلان / الإجراء",
  "records.caseNumber": "رقم القضية",
  "records.recordType": "نوع الإجراء",
  "records.date": "تاريخ التنفيذ",
  "records.searchPlaceholder": "بحث في الأجندة...",
  "records.allRecords": "سجل الأجندة",
  "records.noRecords": "لا توجد بنود في الأجندة",
  "records.noRecordsHint": "اضغط على \"إضافة بند جديد\" لبدء التسجيل",
  "records.partyName": "اسم المعلن إليه",
  "records.address": "العنوان",
  "records.status": "الحالة",
  "records.statusPending": "قيد التنفيذ",
  "records.statusDone": "تم التنفيذ",
  "records.statusFailed": "تعذر التنفيذ",

  // Archive
  "archive.title": "الأرشيف",
  "archive.subtitle": "القضايا والملفات المؤرشفة",
  "archive.totalArchived": "إجمالي المؤرشف",
  "archive.folders": "مجلدات",
  "archive.closedCases": "قضايا منتهية",
  "archive.searchPlaceholder": "بحث في الأرشيف...",
  "archive.archivedItems": "العناصر المؤرشفة",
  "archive.archiveDate": "تاريخ الأرشفة:",
  "archive.noItems": "لا توجد عناصر مؤرشفة",
  "archive.noItemsHint": "ستظهر هنا القضايا والملفات المؤرشفة",
  "archive.caseTypes": "أنواع القضايا",
  "archive.courts": "المحاكم",

  // Notifications
  "notifications.title": "الإشعارات",
  "notifications.newNotifications": "لديك {count} إشعار جديد",
  "notifications.noNewNotifications": "لا توجد إشعارات جديدة",
  "notifications.markAllRead": "تحديد الكل كمقروء",
  "notifications.addNotification": "إضافة إشعار",
  "notifications.addNew": "إضافة إشعار جديد",
  "notifications.notificationTitle": "عنوان الإشعار",
  "notifications.notificationText": "نص الإشعار",
  "notifications.notificationType": "نوع الإشعار",
  "notifications.type.reminder": "تذكير",
  "notifications.type.case": "قضية",
  "notifications.type.file": "ملف",
  "notifications.type.message": "رسالة",
  "notifications.markRead": "تحديد كمقروء",
  "notifications.allNotifications": "جميع الإشعارات",
  "notifications.noNotifications": "لا توجد إشعارات",
  "notifications.noNotificationsHint": "أضف إشعارات جديدة باستخدام زر الإضافة",

  // Assistant
  "assistant.title": "المساعد القانوني الذكي",
  "assistant.subtitle": "اسأل أي سؤال قانوني واحصل على إجابة فورية",
  "assistant.welcome": "مرحباً بك في المساعد القانوني",
  "assistant.welcomeDesc": "أنا هنا لمساعدتك في الاستفسارات القانونية. اختر سؤالاً سريعاً أو اكتب سؤالك الخاص",
  "assistant.placeholder": "اكتب سؤالك القانوني هنا أو اضغط على الميكروفون...",
  "assistant.q1": "ما هي إجراءات رفع دعوى مدنية؟",
  "assistant.q2": "كيف أكتب عقد إيجار قانوني؟",
  "assistant.q3": "ما هي حقوقي في قضايا العمل؟",
  "assistant.q4": "إجراءات تأسيس شركة جديدة",
 "assistant.humanReview": "لابد من المراجعة البشرية",
 "assistant.attachFile": "إرفاق ملف",
 "assistant.fileTooLarge": "حجم الملف يتجاوز الحد الأقصى (5 ميجابايت)",
 "assistant.fileTypeNotSupported": "نوع الملف غير مدعوم. الأنواع المدعومة: TXT, MD, PDF, DOCX",
 "assistant.fileAttached": "تم إرفاق الملف",
 "assistant.removeFile": "إزالة الملف",

  // Legal Memo
  "legalMemo.title": "صياغة المذكرات القانونية",
  "legalMemo.subtitle": "استخدم الذكاء الاصطناعي لصياغة المذكرات والمستندات القانونية",
  "legalMemo.details": "تفاصيل المذكرة",
  "legalMemo.memoType": "نوع المذكرة",
  "legalMemo.selectType": "اختر نوع المذكرة...",
  "legalMemo.caseDetails": "تفاصيل القضية",
  "legalMemo.caseDetailsPlaceholder": "اكتب تفاصيل القضية هنا... مثل: نوع الدعوى، أطراف النزاع، الوقائع، المطلوب...",
  "legalMemo.generate": "صياغة المذكرة",
  "legalMemo.generating": "جاري الصياغة...",
  "legalMemo.memo": "المذكرة",
  "legalMemo.regenerate": "إعادة",
  "legalMemo.emptyHint": "اختر نوع المذكرة واكتب تفاصيل القضية ثم اضغط \"صياغة المذكرة\"",
  "legalMemo.type.defense": "مذكرة دفاع",
  "legalMemo.type.appeal": "مذكرة استئناف",
  "legalMemo.type.cassation": "مذكرة طعن بالنقض",
  "legalMemo.type.reply": "مذكرة رد",
  "legalMemo.type.closing": "مذكرة ختامية",
  "legalMemo.type.complaint": "شكوى",
  "legalMemo.type.contract": "عقد قانوني",

  // Document Analysis
  "docAnalysis.title": "تحليل المستندات بالذكاء الاصطناعي",
  "docAnalysis.subtitle": "ارفع أو الصق مستنداً قانونياً للحصول على تحليل شامل",
  "docAnalysis.document": "المستند",
  "docAnalysis.uploadFile": "رفع ملف نصي",
  "docAnalysis.pastePlaceholder": "الصق نص المستند القانوني هنا... (عقد، حكم، مذكرة، شكوى، إلخ)",
  "docAnalysis.analyze": "تحليل المستند",
  "docAnalysis.analyzing": "جاري التحليل...",
  "docAnalysis.result": "نتيجة التحليل",
  "docAnalysis.analyzingAI": "جاري تحليل المستند بالذكاء الاصطناعي...",
  "docAnalysis.emptyHint": "الصق المستند واضغط \"تحليل\" لعرض النتائج",

  // Smart Search
  "smartSearch.title": "البحث الذكي في القضايا",
  "smartSearch.subtitle": "ابحث بلغة طبيعية في جميع بياناتك",
  "smartSearch.search": "البحث",
  "smartSearch.placeholder": "اكتب ما تبحث عنه... مثال: أرني جميع قضايا الإيجار",
  "smartSearch.results": "نتائج البحث",
  "smartSearch.searching": "جاري البحث بالذكاء الاصطناعي...",
  "smartSearch.emptyHint": "اكتب استفسارك واضغط بحث لعرض النتائج",

  // Contract Analysis
  "contractAnalysis.title": "تحليل العقود",
  "contractAnalysis.subtitle": "تحليل العقود واستخراج المخاطر والتوصيات بالذكاء الاصطناعي",
  "contractAnalysis.contractText": "نص العقد",
  "contractAnalysis.contractType": "نوع العقد (اختياري)",
  "contractAnalysis.selectType": "اختر نوع العقد",
  "contractAnalysis.uploadFile": "رفع ملف (PDF, Word, نصي)",
  "contractAnalysis.pastePlaceholder": "الصق نص العقد هنا... أو ارفع ملف PDF / Word",
  "contractAnalysis.analyze": "تحليل العقد",
  "contractAnalysis.analyzing": "جاري التحليل...",
  "contractAnalysis.result": "نتيجة التحليل",
  "contractAnalysis.analyzingAI": "جاري تحليل العقد بالذكاء الاصطناعي...",
  "contractAnalysis.emptyHint": "الصق نص العقد أو ارفع ملف واضغط \"تحليل\" لعرض النتائج",
  "contractAnalysis.fileAnalysis": "سيتم تحليل الملف مباشرة بالذكاء الاصطناعي",
  "contractAnalysis.removeForManual": "أو أزل الملف للصق النص يدوياً",

  // Smart Interrogation
  "interrogation.title": "الاستجواب الذكي",
  "interrogation.subtitle": "توليد أسئلة استجواب احترافية بالذكاء الاصطناعي",
  "interrogation.caseData": "بيانات القضية",
  "interrogation.caseType": "نوع القضية",
  "interrogation.selectCaseType": "اختر نوع القضية",
  "interrogation.caseDetails": "تفاصيل القضية",
  "interrogation.caseDetailsPlaceholder": "اكتب تفاصيل القضية والوقائع الأساسية...",
  "interrogation.evidence": "الأدلة المتاحة (اختياري)",
  "interrogation.evidencePlaceholder": "اذكر الأدلة والمستندات المتوفرة...",
  "interrogation.targetPerson": "الشخص المستهدف بالاستجواب (اختياري)",
  "interrogation.targetPlaceholder": "مثال: المتهم، الشاهد، المدعى عليه",
  "interrogation.generate": "توليد أسئلة الاستجواب",
  "interrogation.generating": "جاري التوليد...",
  "interrogation.questions": "أسئلة الاستجواب",
  "interrogation.generatingAI": "جاري توليد أسئلة الاستجواب...",
  "interrogation.emptyHint": "أدخل بيانات القضية لتوليد أسئلة الاستجواب",

  // Finances
  "finances.title": "التقارير المالية وتتبع الوقت",
  "finances.subtitle": "إدارة الإيرادات والمصروفات وتسجيل ساعات العمل",
  "finances.financialReports": "التقارير المالية",
  "finances.timeTracking": "تتبع الوقت",

  // Client Intake
  "intake.title": "استقبال العملاء",
  "intake.subtitle": "إدارة طلبات العملاء الجدد",
  "intake.addNewClient": "إضافة عميل جديد",
  "intake.total": "الإجمالي",
  "intake.new": "جديد",
  "intake.reviewed": "تمت المراجعة",
  "intake.converted": "تم التحويل",
  "intake.rejected": "مرفوض",
  "intake.fullName": "الاسم الكامل",
  "intake.phone": "رقم الهاتف (واتساب)",
  "intake.email": "البريد الإلكتروني",
  "intake.caseType": "نوع القضية",
  "intake.caseDescription": "وصف القضية",
  "intake.caseDescPlaceholder": "اشرح تفاصيل القضية باختصار...",
  "intake.preferredDate": "التاريخ المفضل للتواصل",
  "intake.addClient": "إضافة العميل",
  "intake.adding": "جاري الإضافة...",
  "intake.noRequests": "لا توجد طلبات",
  "intake.name": "الاسم",
  "intake.status": "الحالة",
  "intake.dateCol": "التاريخ",
  "intake.actions": "إجراءات",
  "intake.viewDetails": "عرض التفاصيل",
  "intake.convertToClient": "تحويل لعميل",
  "intake.requestDetails": "تفاصيل الطلب",
  "intake.notSpecified": "غير محدد",
  "intake.noDescription": "لا يوجد",

  // Report
  "report.title": "تقرير النظام",
  "report.subtitle": "تقرير شامل بجميع مميزات النظام",
  "report.print": "طباعة التقرير",
  "report.about": "نبذة عن النظام",

  // Team Tasks
  "teamTasks.title": "توزيع المهام",
  "teamTasks.subtitle": "إدارة وتوزيع المهام على فريق العمل",
  "teamTasks.addMember": "إضافة عضو",
  "teamTasks.addNewMember": "إضافة عضو جديد للفريق",
  "teamTasks.memberName": "اسم العضو",
  "teamTasks.memberEmail": "البريد الإلكتروني",
  "teamTasks.distributeTask": "توزيع مهمة",
  "teamTasks.distributeNewTask": "توزيع مهمة جديدة",
  "teamTasks.taskTitle": "عنوان المهمة",
  "teamTasks.taskDescription": "وصف المهمة",
  "teamTasks.selectAssignee": "اختر العضو المسؤول",
  "teamTasks.distributeBtn": "توزيع المهمة",
  "teamTasks.filterByMember": "تصفية حسب العضو:",
  "teamTasks.allMembers": "جميع الأعضاء",
  "teamTasks.tasksTab": "المهام",
  "teamTasks.membersTab": "الفريق",
  "teamTasks.pendingTasks": "مهام معلقة",
  "teamTasks.completedTasks": "مهام مكتملة",
  "teamTasks.teamMembers": "أعضاء الفريق",
  "teamTasks.noPending": "لا توجد مهام معلقة",
  "teamTasks.noCompleted": "لا توجد مهام مكتملة",

  // Team Performance
  "teamPerformance.title": "أداء الفريق",
  "teamPerformance.subtitle": "متابعة تقدم المحامين وأدائهم",
  "teamPerformance.teamMembers": "أعضاء الفريق",
  "teamPerformance.completedTasks": "مهام مكتملة",
  "teamPerformance.assignedCases": "قضايا مسندة",
  "teamPerformance.avgCompletion": "متوسط الإنجاز",
  "teamPerformance.overdueTasks": "مهمة متأخرة تحتاج متابعة",
  "teamPerformance.noMembers": "لا يوجد أعضاء في الفريق",
  "teamPerformance.noMembersHint": "أضف أعضاء من صفحة \"توزيع المهام\" أولاً",
  "teamPerformance.completionRate": "نسبة الإنجاز",
  "teamPerformance.completed": "مكتملة",
  "teamPerformance.inProgress": "جارية",
  "teamPerformance.overdue": "متأخرة",
  "teamPerformance.activeCases": "قضية نشطة",
  "teamPerformance.closedCases": "منتهية",

  // Subscribed Offices
  "offices.title": "إدارة المكاتب المشتركة",
  "offices.subtitle": "تتبع وإدارة اشتراكات المكاتب",
  "offices.addOffice": "إضافة مكتب",
  "offices.editOffice": "تعديل بيانات المكتب",
  "offices.addNewOffice": "إضافة مكتب جديد",
  "offices.totalOffices": "إجمالي المكاتب",
  "offices.activeSubscription": "اشتراك نشط",
  "offices.totalUsers": "إجمالي المستخدمين",
  "offices.totalRevenue": "إجمالي الإيرادات",
  "offices.officeName": "اسم المكتب",
  "offices.contactPerson": "المسؤول",
  "offices.plan": "الباقة",
  "offices.amount": "المبلغ",
  "offices.users": "المستخدمين",
  "offices.expiresOn": "ينتهي في",
  "offices.status": "الحالة",
  "offices.status.active": "نشط",
  "offices.status.expired": "منتهي",
  "offices.status.trial": "تجريبي",
  "offices.planType": "نوع الباقة",
  "offices.plan.monthly": "شهري",
  "offices.plan.quarterly": "ربع سنوي",
  "offices.plan.semiAnnual": "نصف سنوي",
  "offices.plan.annual": "سنوي",
  "offices.subscriptionStart": "بداية الاشتراك",
  "offices.subscriptionEnd": "نهاية الاشتراك",
  "offices.maxUsers": "عدد المستخدمين",
  "offices.address": "العنوان",
  "offices.notes": "ملاحظات",
  "offices.confirmDelete": "تأكيد الحذف",
  "offices.deleteConfirmMsg": "هل أنت متأكد من حذف هذا المكتب؟",
  "offices.update": "تحديث",
  "offices.noOffices": "لا توجد مكاتب مسجلة بعد",
  "offices.expiringWarning": "{count} مكتب اشتراكه ينتهي خلال 7 أيام:",

  // Toast messages
  "toast.added": "تم الإضافة",
  "toast.edited": "تم التعديل",
  "toast.deleted": "تم الحذف",
  "toast.saved": "تم الحفظ",
  "toast.error": "خطأ",
  "toast.fillRequired": "يرجى ملء الحقول المطلوبة",
  "toast.fillAll": "يرجى ملء جميع الحقول",
  "toast.passwordShort": "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
  "toast.passwordMismatch": "كلمتا المرور غير متطابقتين",
  "toast.passwordUpdated": "تم تغيير كلمة المرور بنجاح",
  "toast.passwordFailed": "فشل تحديث كلمة المرور",

  // Courts
  "court.partial": "المحكمة الجزئية",
  "court.primary": "المحكمة الابتدائية",
  "court.appeal": "محكمة الاستئناف",
  "court.cassation": "محكمة النقض",
  "court.administrative": "المحكمة الإدارية",
  "court.family": "محكمة الأسرة",
  "court.criminal": "المحكمة الجنائية",
  "court.commercial": "المحكمة التجارية",
  "court.other": "أخرى",

  // Case types for interrogation
  "caseType.criminal": "جنائية",
  "caseType.civil": "مدنية",
  "caseType.commercial": "تجارية",
  "caseType.labor": "عمالية",
  "caseType.personalStatus": "أحوال شخصية",
  "caseType.administrative": "إدارية",
  "caseType.rental": "إيجارات",
  "caseType.inheritance": "تركات",

  // Case Detail
  "caseDetail.loading": "جاري التحميل...",
  "caseDetail.caseNumber": "رقم:",
  "caseDetail.upcomingSessions": "جلسات قادمة",
  "caseDetail.pendingTasks": "مهام معلقة",
  "caseDetail.documents": "مستندات",
  "caseDetail.netFinance": "صافي مالي",
  "caseDetail.sessions": "الجلسات",
  "caseDetail.tasks": "المهام",
  "caseDetail.documentsTab": "المستندات",
  "caseDetail.finances": "المالية",
  "caseDetail.addSession": "إضافة جلسة",
  "caseDetail.addNewSession": "إضافة جلسة جديدة",
  "caseDetail.court": "المحكمة",
  "caseDetail.room": "القاعة",
  "caseDetail.roomPlaceholder": "رقم القاعة",
  "caseDetail.date": "التاريخ",
  "caseDetail.time": "الوقت",
  "caseDetail.reminderBefore": "التذكير قبل",
  "caseDetail.oneDay": "يوم",
  "caseDetail.twoDays": "يومين",
  "caseDetail.threeDays": "3 أيام",
  "caseDetail.oneWeek": "أسبوع",
  "caseDetail.notes": "ملاحظات",
  "caseDetail.notesPlaceholder": "ملاحظات...",
  "caseDetail.addSessionBtn": "إضافة الجلسة",
  "caseDetail.noSessions": "لا توجد جلسات",
  "caseDetail.ended": "منتهية",
  "caseDetail.today": "اليوم",
  "caseDetail.tomorrow": "غداً",
  "caseDetail.daysLeft": "بعد {days} أيام",
  "caseDetail.addTask": "إضافة مهمة",
  "caseDetail.addNewTask": "إضافة مهمة جديدة",
  "caseDetail.taskTitle": "عنوان المهمة",
  "caseDetail.taskDesc": "وصف المهمة",
  "caseDetail.priority": "الأولوية",
  "caseDetail.priorityHigh": "عاجل",
  "caseDetail.priorityMedium": "متوسط",
  "caseDetail.priorityLow": "عادي",
  "caseDetail.pending": "معلقة",
  "caseDetail.completed": "مكتملة",
  "caseDetail.noPendingTasks": "لا توجد مهام معلقة",
  "caseDetail.noCompletedTasks": "لا توجد مهام مكتملة",
  "caseDetail.addDocument": "إضافة مستند جديد",
  "caseDetail.docName": "اسم المستند",
  "caseDetail.docType": "نوع المستند",
  "caseDetail.noDocuments": "لا توجد مستندات",
  "caseDetail.addFinance": "إضافة",
  "caseDetail.addFinanceTitle": "إضافة حركة مالية",
  "caseDetail.income": "إيراد",
  "caseDetail.expense": "مصروف",
  "caseDetail.amount": "المبلغ",
  "caseDetail.description": "الوصف",
  "caseDetail.revenue": "الإيرادات",
  "caseDetail.expenses": "المصروفات",
  "caseDetail.net": "الصافي",
  "caseDetail.noFinances": "لا توجد حركات مالية",
  "caseDetail.notSpecified": "غير محدد",
  "caseDetail.selectCourt": "اختر المحكمة",

  // Document types
  "docType.contract": "عقد",
  "docType.claim": "صحيفة دعوى",
  "docType.judgment": "حكم",
  "docType.power": "توكيل",
  "docType.evidence": "مستند إثبات",
  "docType.correspondence": "مراسلات",
  "docType.other": "أخرى",

  // Case status
  "status.active": "جارية",
  "status.pending": "معلقة",
  "status.closed": "منتهية",

  // Finances Tab
  "financesTab.newTransaction": "عملية مالية جديدة",
  "financesTab.addTransaction": "إضافة عملية مالية",
  "financesTab.selectCase": "اختر القضية",
  "financesTab.income": "إيراد",
  "financesTab.expense": "مصروف",
  "financesTab.amount": "المبلغ",
  "financesTab.description": "الوصف",
  "financesTab.add": "إضافة",
  "financesTab.totalIncome": "إجمالي الإيرادات",
  "financesTab.totalExpenses": "إجمالي المصروفات",
  "financesTab.netProfit": "صافي الربح",
  "financesTab.allCases": "كل القضايا",
  "financesTab.createdBy": "بواسطة",
  "financesTab.date": "التاريخ",
  "financesTab.case": "القضية",
  "financesTab.type": "النوع",
  "financesTab.noTransactions": "لا توجد عمليات مالية",
  "financesTab.noTransactionsHint": "اضغط على \"عملية مالية جديدة\" لإضافة إيراد أو مصروف",
  "financesTab.unknown": "غير معروف",
  "financesTab.currency": "د.ك",

  // Time Tracking Tab
  "timeTracking.logHours": "تسجيل ساعات",
  "timeTracking.logNewHours": "تسجيل ساعات عمل جديدة",
  "timeTracking.selectCase": "اختر القضية *",
  "timeTracking.workDescription": "وصف العمل المنجز",
  "timeTracking.hours": "عدد الساعات *",
  "timeTracking.hoursExample": "مثال: 2.5",
  "timeTracking.hourlyRate": "سعر الساعة (د.ك) *",
  "timeTracking.rateExample": "مثال: 50",
  "timeTracking.calculatedTotal": "الإجمالي المحسوب:",
  "timeTracking.register": "تسجيل",
  "timeTracking.totalHours": "إجمالي الساعات",
  "timeTracking.totalFees": "إجمالي الرسوم",
  "timeTracking.casesCount": "عدد القضايا",
  "timeTracking.feeSummary": "ملخص الرسوم لكل قضية",
  "timeTracking.entry": "تسجيل",
  "timeTracking.hour": "ساعة",
  "timeTracking.noEntries": "لا توجد سجلات وقت",
  "timeTracking.noEntriesHint": "اضغط على \"تسجيل ساعات\" لإضافة سجل جديد",
  "timeTracking.filterByCase": "تصفية حسب القضية",
  "timeTracking.allCases": "جميع القضايا",
  "timeTracking.editHours": "تعديل ساعات العمل",
  "timeTracking.save": "حفظ التعديلات",

  // Case Documents Dialog
  "caseDocs.title": "مستندات القضية:",
  "caseDocs.docName": "اسم المستند",
  "caseDocs.docType": "نوع المستند",
  "caseDocs.docUrl": "رابط المستند (اختياري)",
  "caseDocs.add": "إضافة",
  "caseDocs.cancel": "إلغاء",
  "caseDocs.addNew": "إضافة مستند جديد",
  "caseDocs.noDocuments": "لا توجد مستندات مرفقة",
  "caseDocs.noDocumentsHint": "اضغط على \"إضافة مستند جديد\" لإرفاق مستندات",
  "caseDocs.errorNoName": "يرجى إدخال اسم المستند",
  "caseDocs.added": "تم إضافة المستند بنجاح",
  "caseDocs.deleted": "تم حذف المستند بنجاح",

  // Case Prediction Dialog
  "prediction.title": "تنبؤ نتائج القضية",
  "prediction.caseNumber": "رقم القضية:",
  "prediction.type": "النوع:",
  "prediction.client": "الموكل:",
  "prediction.court": "المحكمة:",
  "prediction.analyze": "تحليل وتنبؤ بالنتائج",
  "prediction.analyzing": "جاري تحليل القضية...",
  "prediction.error": "حدث خطأ أثناء التنبؤ",
  "prediction.rateLimited": "تم تجاوز حد الطلبات، يرجى المحاولة لاحقاً",
  "prediction.noBalance": "يرجى إضافة رصيد لحساب AI",

  // Case Summary Dialog
  "summary.title": "تلخيص القضية بالذكاء الاصطناعي",
  "summary.summarizing": "جاري التلخيص...",
  "summary.copy": "نسخ",
  "summary.copied": "تم النسخ",
  "summary.regenerate": "إعادة التلخيص",
  "summary.error": "حدث خطأ في الاتصال",

  // Client Portal Dialog
  "clientPortal.info": "المعلومات",
  "clientPortal.cases": "القضايا",
  "clientPortal.documents": "المستندات",
  "clientPortal.phone": "رقم الهاتف",
  "clientPortal.email": "البريد الإلكتروني",
  "clientPortal.casesCount": "عدد القضايا",
  "clientPortal.notSpecified": "غير محدد",
  "clientPortal.nextSession": "الجلسة القادمة:",
  "clientPortal.caseNumber": "رقم:",
  "clientPortal.noCases": "لا توجد قضايا لهذا الموكل",
  "clientPortal.noDocuments": "لا توجد مستندات لهذا الموكل",
  "clientPortal.caseLabel": "قضية:",

  // Consultation Lawyer Dialog
  "consult.title": "محامي استشارات",
  "consult.login": "تسجيل الدخول",
  "consult.createProfile": "إنشاء بطاقة تعريفية",
  "consult.viewProfile": "بطاقتك التعريفية",
  "consult.alreadyLoggedIn": "أنت مسجل دخول بالفعل كمحامي استشارات",
  "consult.viewMyProfile": "عرض بطاقتي التعريفية",
  "consult.createMyProfile": "إنشاء بطاقتي التعريفية",
  "consult.chooseOption": "لإنشاء بطاقتك التعريفية وعرضها للعملاء، يرجى اختيار أحد الخيارين:",
  "consult.loginTitle": "تسجيل الدخول",
  "consult.loginDesc": "لدي حساب بالفعل، أريد تسجيل الدخول وإنشاء بطاقتي",
  "consult.contactAdmin": "تواصل مع الأدمن",
  "consult.contactAdminDesc": "تواصل معنا عبر واتساب للحصول على إذن الانضمام",
  "consult.back": "رجوع",
  "consult.email": "البريد الإلكتروني",
  "consult.password": "كلمة المرور",
  "consult.emailRequired": "البريد الإلكتروني مطلوب",
  "consult.emailInvalid": "البريد الإلكتروني غير صالح",
  "consult.emailNotAllowed": "هذا البريد غير مصرح له بالدخول",
  "consult.passwordRequired": "كلمة المرور مطلوبة",
  "consult.passwordShort": "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
  "consult.logging": "جاري التحميل...",
  "consult.loginBtn": "تسجيل الدخول",
  "consult.loginError": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "consult.loginSuccess": "تم تسجيل الدخول",
  "consult.welcomeBack": "مرحباً بك مجدداً",
  "consult.canCreateProfile": "يمكنك الآن إنشاء بطاقتك التعريفية",
  "consult.addPhoto": "إضافة صورة",
  "consult.fullName": "الاسم الكامل",
  "consult.specialty": "التخصص",
  "consult.specialtyPlaceholder": "محامي جنائي / مستشار قانوني",
  "consult.briefDescription": "وصف مختصر",
  "consult.descriptionPlaceholder": "اكتب وصفاً مختصراً عن خبرتك...",
  "consult.whatsapp": "رقم واتساب",
  "consult.saving": "جاري الحفظ...",
  "consult.saveProfile": "حفظ البطاقة التعريفية",
  "consult.saved": "تم حفظ بطاقتك التعريفية بنجاح",
  "consult.viewAllLawyers": "عرض جميع المحامين",
  "consult.contactViaWhatsapp": "تواصل عبر واتساب",
  "consult.editProfile": "تعديل البطاقة",

  // Report page
  "report.printHeader": "نظام إدارة مكتب المحاماة",
  "report.printSubtitle": "تقرير شامل بجميع المميزات والخدمات",
  "report.printDate": "تاريخ التقرير:",
  "report.aboutDesc": "نظام إدارة مكتب المحاماة هو حل متكامل ومتطور مصمم خصيصاً لتلبية احتياجات مكاتب المحاماة العربية. يوفر النظام أدوات شاملة لإدارة القضايا والعملاء والمهام والجلسات والملفات بطريقة سهلة وفعالة. تم تطوير النظام باستخدام أحدث التقنيات لضمان الأداء السريع والأمان العالي وسهولة الاستخدام. يدعم النظام اللغة العربية بالكامل مع واجهة مستخدم أنيقة ومتجاوبة تعمل على جميع الأجهزة.",
  "report.technicalFeatures": "المميزات التقنية",
  "report.security": "الأمان",
  "report.securityDesc": "حفظ البيانات محلياً بشكل آمن",
  "report.speed": "السرعة",
  "report.speedDesc": "أداء سريع وسلس بدون تأخير",
  "report.autoSave": "الحفظ التلقائي",
  "report.autoSaveDesc": "حفظ البيانات تلقائياً عند أي تغيير",
  "report.analytics": "التحليلات",
  "report.analyticsDesc": "رسوم بيانية تفاعلية للإحصائيات",
  "report.modulesTitle": "الوحدات والمميزات",
  "report.interconnectedTitle": "الأنظمة المترابطة",
  "report.interconnectedDesc": "الأجزاء المتكاملة التي تعمل معاً لتوفير تجربة إدارية موحدة",
  "report.summaryTitle": "ملخص النظام",
  "report.mainModules": "وحدات رئيسية",
  "report.integratedFeatures": "ميزة متكاملة",
  "report.arabicSupport": "دعم عربي",
  "report.alwaysAvailable": "متاح دائماً",
  "report.aiIntegrated": "ذكاء اصطناعي مدمج",
  "report.createdOn": "تم إنشاء هذا التقرير بتاريخ",
  "report.allRightsReserved": "نظام إدارة مكتب المحاماة - جميع الحقوق محفوظة",
  "report.taskDistribution": "نظام توزيع المهام والإدارة الهرمية",
  "report.taskDistributionDesc": "يعتمد النظام على هيكل إداري متكامل يربط بين المدير العام ومديري الفرق والمحامين لضمان توزيع العمل بكفاءة ومراقبة الأداء.",
  "report.generalManager": "المدير العام",
  "report.teamManager": "مدير الفريق",
  "report.lawyer": "المحامي",
  "report.caseLinking": "ربط القضايا بالجلسات والمهام والمستندات",
  "report.caseLinkingDesc": "كل قضية مرتبطة بجميع عناصرها في صفحة موحدة، مما يتيح للمحامي إدارة الدعوى بالكامل من مكان واحد دون التنقل بين الصفحات.",

  // Chart labels
  "chart.casesDistribution": "توزيع القضايا",
  "chart.active": "جارية",
  "chart.pending": "معلقة",
  "chart.closed": "منتهية",
  "chart.monthlyClients": "العملاء شهرياً",
  "chart.clients": "العملاء",

  // Landing Page - Navbar
  "landing.nav.home": "الرئيسية",
  "landing.nav.login": "تسجيل الدخول",
  "landing.nav.services": "خدماتنا",
 "landing.nav.contact": "تواصل معنا",
 "landing.nav.portal": "ابدأ الآن",
  "landing.nav.joinUs": "انضم إلينا",
  "landing.nav.darkMode": "تفعيل الوضع الداكن",
  "landing.nav.lightMode": "تفعيل الوضع الفاتح",
  "landing.nav.joinTitle": "انضم إلينا",
  "landing.nav.chooseAccount": "اختر نوع حسابك",
  "landing.nav.lawyer": "محامي",
  "landing.nav.lawyerDesc": "إدارة مكتب المحاماة",
  "landing.nav.consultLawyer": "محامي استشارات",
  "landing.nav.consultLawyerDesc": "تقديم استشارات قانونية أونلاين",

  // Landing Page - Hero Carousel
  "landing.hero.slide1Title": "إدارة مكتبك القانوني بذكاء",
  "landing.hero.slide1Subtitle": "نظام متكامل لإدارة القضايا والجلسات والعملاء",
  "landing.hero.slide2Title": "الذكاء الاصطناعي في خدمة\nالقانون",
  "landing.hero.slide2Subtitle": "تحليل المستندات والعقود وإعداد المذكرات تلقائياً",
  "landing.hero.slide3Title": "بحث قانوني متقدم",
  "landing.hero.slide3Subtitle": "الوصول الفوري للقوانين والسوابق القضائية",
  "landing.hero.prevSlide": "الشريحة السابقة",
  "landing.hero.nextSlide": "الشريحة التالية",

  // Landing Page - Auth Section
  "landing.auth.welcome": "مرحباً بك فى Legal AI",
  "landing.auth.chooseAccount": "اختر نوع حسابك للمتابعة",
  "landing.auth.clients": "الموكلين",
  "landing.auth.clientsDesc": "أريد حجز استشارة قانونية",
  "landing.auth.lawyer": "محامي",
  "landing.auth.lawyerDesc": "أريد إدارة مكتبي",
  "landing.auth.companies": "الشركات التجارية",
  "landing.auth.companiesDesc": "استشارات وعقود للشركات والمؤسسات",

  // Company portal
  "company.portal": "بوابة الشركات",
  "company.portalSubtitle": "إدارة شاملة للشئون المالية والإدارية والقانونية",
  "company.sections": "الأقسام",

  "company.accounting.title": "المحاسب القانوني",
  "company.accounting.desc": "إدارة الحسابات والتقارير المالية والضرائب وفق المعايير القانونية",
  "company.accounting.f1": "الفواتير والإيرادات",
  "company.accounting.f1Desc": "تتبع الفواتير الصادرة والواردة وإدارة الإيرادات بدقة عالية",
  "company.accounting.f2": "التقارير المالية",
  "company.accounting.f2Desc": "ميزانيات شهرية وسنوية وتحليلات أداء مالي شاملة",
  "company.accounting.f3": "الضرائب والزكاة",
  "company.accounting.f3Desc": "حساب الضرائب وإقرارات الزكاة وفق التشريعات السارية",
  "company.accounting.f4": "كشوف المرتبات",
  "company.accounting.f4Desc": "إعداد كشوف المرتبات والاستحقاقات والخصومات للموظفين",

  "company.administrative.title": "الشئون الإدارية",
  "company.administrative.desc": "إدارة الموظفين والمراسلات والعقود الإدارية للشركة",
  "company.administrative.f1": "إدارة الموظفين",
  "company.administrative.f1Desc": "ملفات الموظفين، الإجازات، الحضور والانصراف، وتقييم الأداء",
  "company.administrative.f2": "المراسلات والقرارات",
  "company.administrative.f2Desc": "صياغة وأرشفة المراسلات الرسمية والقرارات الإدارية",
  "company.administrative.f3": "هيكل الشركة",
  "company.administrative.f3Desc": "إدارة الفروع والأقسام والصلاحيات الإدارية",
  "company.administrative.f4": "العقود الإدارية",
  "company.administrative.f4Desc": "إدارة عقود الموردين والشركاء والاتفاقيات الإدارية",

  "company.legal.title": "الشئون القانونية",
  "company.legal.desc": "متابعة القضايا والعقود والاستشارات القانونية للشركة",
  "company.legal.f1": "العقود التجارية",
  "company.legal.f1Desc": "صياغة ومراجعة العقود التجارية وعقود الشراكة والتوريد",
  "company.legal.f2": "الامتثال القانوني",
  "company.legal.f2Desc": "ضمان التزام الشركة بالتشريعات واللوائح المحلية والدولية",
  "company.legal.f3": "إدارة القضايا",
  "company.legal.f3Desc": "متابعة القضايا المرفوعة من وعلى الشركة وحالاتها أمام المحاكم",
  "company.legal.f4": "الاستشارات القانونية",
  "company.legal.f4Desc": "استشارات في الأنظمة الشركاتية والملكية الفكرية والعمل",

  // Company Accounting Excel tool
  "companyAcc.title": "تحليل ملفات Excel بالذكاء الاصطناعي",
  "companyAcc.uploadExcel": "رفع ملف Excel (xlsx, xls, csv)",
  "companyAcc.questionLabel": "سؤالك أو طلبك للذكاء الاصطناعي",
  "companyAcc.questionPlaceholder": "مثال: لخّص لي إجمالي المبيعات لكل شهر، أو احسب صافي الربح، أو حدد الأخطاء المحاسبية...",
  "companyAcc.questionHint": "اتركه فارغاً للحصول على تحليل مالي شامل افتراضي",
  "companyAcc.analyze": "تحليل بالذكاء الاصطناعي",
  "companyAcc.analyzing": "جاري التحليل...",
  "companyAcc.analyzingAI": "الذكاء الاصطناعي يحلل ملفك الآن",
  "companyAcc.result": "نتيجة التحليل",
  "companyAcc.emptyHint": "ارفع ملف Excel واكتب سؤالك ليبدأ التحليل",
  "companyAcc.fileTooLarge": "الملف كبير جداً (الحد الأقصى 15 ميجا)",
  "companyAcc.invalidFile": "صيغة الملف غير مدعومة، استخدم xlsx أو xls أو csv",
  "companyAcc.parseError": "فشل قراءة الملف",
  "companyAcc.uploadFirst": "ارفع ملف Excel أولاً",
  "companyAcc.sheet": "ورقة",
  "companyAcc.rows": "صف",
  "companyAcc.cols": "عمود",
  "companyAcc.userQuestion": "طلب المستخدم",
  "companyAcc.fileContents": "محتويات الملف",
  "companyAcc.defaultPrompt": "قم بتحليل بيانات هذا الملف المحاسبي تحليلاً شاملاً، واستخرج المؤشرات المالية الأساسية، ولخّص الأرقام المهمة، واقترح ملاحظات وتحسينات للقوائم المالية.",

  // Company Administrative lists
  "companyAdmin.archive": "الأرشفة",
  "companyAdmin.employees": "العاملون",
  "companyAdmin.items": "عنصر",
  "companyAdmin.archiveTitle": "عنوان المستند",
  "companyAdmin.archiveCategory": "التصنيف",
  "companyAdmin.addArchive": "إضافة للأرشيف",
  "companyAdmin.noArchive": "لا توجد عناصر مؤرشفة بعد",
  "companyAdmin.itemAdded": "تمت الإضافة بنجاح",
  "companyAdmin.titleRequired": "العنوان مطلوب",
  "companyAdmin.general": "عام",
  "companyAdmin.employeeName": "اسم الموظف",
  "companyAdmin.employeeRole": "الوظيفة",
  "companyAdmin.employeeEmail": "البريد الإلكتروني",
  "companyAdmin.employeePhone": "رقم الهاتف",
  "companyAdmin.addEmployee": "إضافة موظف",
  "companyAdmin.noEmployees": "لا يوجد موظفون مسجلون بعد",
  "companyAdmin.employeeAdded": "تمت إضافة الموظف",
  "companyAdmin.nameRequired": "الاسم مطلوب",
  "companyAdmin.employee": "موظف",
  "landing.auth.student": "طالب",
  "landing.auth.studentDesc": "الأبحاث التعليمية القانونية",
  "landing.auth.paidNotice": "✦ نظام إدارة المكتب القانوني — خدمة مدفوعة ✦",
  "landing.auth.learnMore": "تعرّف على خدماتنا",
  "landing.auth.servicesTitle": "خدمات منصة Legal AI",
  "landing.auth.service1Title": "مساعد قانوني ذكي",
  "landing.auth.service1Desc": "مساعد يعمل بالذكاء الاصطناعي للإجابة على استفساراتك القانونية فوراً",
  "landing.auth.service2Title": "إدارة القضايا والملفات",
  "landing.auth.service2Desc": "تنظيم كامل لجميع قضاياك ومستنداتك في مكان واحد",
  "landing.auth.service3Title": "تتبع الجلسات والمواعيد",
  "landing.auth.service3Desc": "تذكيرات تلقائية بمواعيد الجلسات وإدارة التقويم",
  "landing.auth.service4Title": "التقارير المالية",
  "landing.auth.service4Desc": "تتبع الإيرادات والمصروفات وإصدار الفواتير تلقائياً",
  "landing.auth.service5Title": "إدارة فريق العمل",
  "landing.auth.service5Desc": "توزيع المهام ومتابعة أداء فريق المكتب",
  "landing.auth.service6Title": "تحليل العقود والمستندات",
  "landing.auth.service6Desc": "تحليل ذكي للعقود واستخراج البنود المهمة تلقائياً",

  // Landing Page - Login Form
  "landing.login.lawyerAccount": "حساب محامي",
  "landing.login.consultAccount": "حساب محامي استشارات",
  "landing.login.clientAccount": "حساب الموكلين",
  "landing.login.title": "تسجيل الدخول",
  "landing.login.name": "الاسم",
  "landing.login.email": "البريد الإلكتروني",
  "landing.login.password": "كلمة المرور",
  "landing.login.rememberMe": "تذكرني",
  "landing.login.forgotPassword": "نسيت كلمة المرور؟",
  "landing.login.submit": "تسجيل الدخول",
  "landing.login.processing": "جاري المعالجة...",
  "landing.login.changeType": "​",
  "landing.login.paidNotice": "نظام إدارة المكتب خدمة مدفوعة",
  "landing.login.supportInquiry": "استفسار",
  "landing.login.techSupport": "الدعم الفني",
  "landing.login.supportTitle": "التواصل والدعم",
  "landing.login.whatsappInquiry": "واتساب استفسار",
  "landing.login.whatsappContact": "واتساب تواصل",
  "landing.login.techSupport1": "دعم فني ١",
  "landing.login.techSupport2": "دعم فني ٢",

  // Landing Page - Validation
  "landing.validation.emailRequired": "البريد الإلكتروني مطلوب",
  "landing.validation.emailInvalid": "البريد الإلكتروني يجب أن يحتوي على @",
  "landing.validation.emailFormat": "البريد الإلكتروني غير صالح",
  "landing.validation.passwordRequired": "كلمة المرور مطلوبة",
  "landing.validation.passwordShort": "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
  "landing.validation.dataError": "خطأ في البيانات",
  "landing.validation.unauthorized": "غير مصرح",
  "landing.validation.consultUnauthorized": "هذا البريد غير مصرح له بالدخول كمحامي استشارات",
  "landing.validation.lawyerUnauthorized": "هذا البريد غير مصرح له بالدخول كمحامي. استخدم بريد المحامي الخاص بك",
  "landing.validation.consultRedirect": "محامي الاستشارات يسجل الدخول من زر 'دخول' → محامي استشارات",
  "landing.validation.loginError": "خطأ في تسجيل الدخول",
  "landing.validation.wrongCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "landing.validation.accountExpired": "انتهت صلاحية الحساب",
  "landing.validation.accountExpiredDesc": "انتهت مدة صلاحية حسابك. تواصل مع المدير لتجديد الصلاحية.",
  "landing.validation.loginSuccess": "تم تسجيل الدخول",
  "landing.validation.welcomeLawyer": "مرحباً بك في نظام إدارة المكتب",
  "landing.validation.welcomeConsult": "مرحباً بك في لوحة الاستشارات",
  "landing.validation.welcomeClient": "مرحباً بك",
  "landing.validation.unexpectedError": "خطأ",
  "landing.validation.tryAgain": "حدث خطأ غير متوقع، حاول مرة أخرى",

  // Landing Page - Services Section
  "landing.services.aiAssistant": "المساعد القانوني الذكي",
  "landing.services.aiAssistantDesc": "ذكاء اصطناعي للإجابة على استفساراتك القانونية فوراً",
  "landing.services.caseManagement": "إدارة القضايا",
  "landing.services.caseManagementDesc": "تتبع القضايا والجلسات والمواعيد بشكل منظم",
  "landing.services.contractAnalysis": "تحليل العقود",
  "landing.services.contractAnalysisDesc": "تحليل المستندات واستخراج البنود المهمة تلقائياً",
  "landing.services.legalMemos": "المذكرات القانونية",
  "landing.services.legalMemosDesc": "إنشاء مذكرات احترافية بالذكاء الاصطناعي",
  "landing.services.financialReports": "التقارير المالية",
  "landing.services.financialReportsDesc": "تتبع الإيرادات والمصروفات وإصدار الفواتير",
  "landing.services.teamManagement": "إدارة فريق العمل",
  "landing.services.teamManagementDesc": "توزيع المهام ومتابعة أداء الفريق",

  // Landing Page - Footer
  "landing.footer.brandDesc": "منصة قانونية ذكية تجمع بين الذكاء الاصطناعي وإدارة المكاتب القانونية لتوفير تجربة احترافية متكاملة",
  "landing.footer.services": "خدماتنا",
  "landing.footer.quickLinks": "روابط سريعة",
  "landing.footer.contactUs": "تواصل معنا",
  "landing.footer.home": "الرئيسية",
  "landing.footer.features": "المميزات",
  "landing.footer.login": "تسجيل الدخول",
  "landing.footer.whatsappInquiry": "واتساب استفسار",
  "landing.footer.techSupport": "الدعم الفني",
  "landing.footer.callUs": "اتصل بنا",
  "landing.footer.copyright": "جميع الحقوق محفوظة.",

  // Client Home Page
  "client.nav.services": "الخدمات",
  "client.nav.consultations": "الاستشارات",
  "client.nav.testimonials": "آراء العملاء",
  "client.nav.logout": "خروج",
  "client.services.title": "خدماتنا القانونية",
  "client.services.subtitle": "نقدم لك أفضل الخدمات القانونية مع فريق من المحامين المتخصصين",
  "client.bookConsultation": "احجز استشارتك الآن",
  "client.onlineConsultation": "استشارة أونلاين",
  "client.onlineDesc": "عبر مكالمة فيديو",
  "client.onlineDuration": "مدة الاستشارة: 30-60 دقيقة",
  "client.onlinePlatform": "عبر Zoom أو Google Meet",
  "client.offlineConsultation": "استشارة حضورية",
  "client.offlineDesc": "في مكتب المحاماة",
  "client.offlineDuration": "مدة الاستشارة: 45-90 دقيقة",
  "client.offlineLocation": "في مقر المكتب الرئيسي",
  "client.selected": "مختار",
  "client.whyChooseUs": "لماذا تختارنا",
  "client.confidential": "سرية تامة",
  "client.confidentialDesc": "حماية بياناتك بأعلى المعايير",
  "client.fastResponse": "استجابة سريعة",
  "client.fastResponseDesc": "رد خلال 24 ساعة",
  "client.experience": "خبرة واسعة",
  "client.experienceDesc": "محامون متخصصون",
  "client.followUp": "متابعة مستمرة",
  "client.followUpDesc": "خطوة بخطوة حتى النتيجة",
  "client.availableLawyers": "المحامون المتاحون",
  "client.contactWhatsapp": "تواصل عبر واتساب",
  "client.whatsapp": "واتساب",
  "client.bookAppointment": "حجز موعد",
  "client.bookAppointmentTitle": "حجز موعد",
  "client.scheduleAppointment": "احجز موعداً مع المحامي المناسب",
  "client.feeCalculator": "حاسبة الرسوم القضائية",
  "client.feeCalculatorDesc": "احسب رسوم قضيتك بدقة وسرعة",
  "client.legalTemplates": "نماذج قانونية جاهزة",
  "client.legalTemplatesDesc": "حمّل نماذج عقود وشكاوى ومذكرات",
  "client.caseTracker": "متابعة القضايا",
  "client.caseTrackerDesc": "تابع حالة قضيتك بشكل مباشر",
  "client.whatsappFormTitle": "تواصل عبر واتساب",
  "client.fullName": "الاسم الكامل",
  "client.enterName": "أدخل اسمك",
  "client.problemDesc": "وصف المشكلة",
  "client.problemPlaceholder": "اشرح مشكلتك القانونية باختصار...",
  "client.sendWhatsapp": "إرسال عبر واتساب",
  "client.caseTrackerTitle": "متابعة حالة القضية",
  "client.caseTrackerHint": "أدخل اسمك ورقم هاتفك المسجل لدى المحامي",
  "client.phonePlaceholder": "رقم الهاتف (مثال: +201004298934)",
  "client.searchCases": "بحث عن قضاياي",
  "client.searching": "جاري البحث...",
  "client.noCasesFound": "لم يتم العثور على قضايا مرتبطة بهذه البيانات",
  "client.caseNumber": "رقم القضية:",
  "client.caseType": "النوع:",
  "client.court": "المحكمة:",
  "client.nextSession": "الجلسة القادمة:",
  "client.statusActive": "جارية",
  "client.statusPending": "معلقة",
  "client.statusClosed": "منتهية",
  "client.feeCalcTitle": "حاسبة الرسوم القضائية",
  "client.caseTypeLabel": "نوع القضية",
  "client.selectCaseType": "اختر نوع القضية",
  "client.civil": "مدني",
  "client.commercial": "تجاري",
  "client.family": "أحوال شخصية",
  "client.criminal": "جنائي",
  "client.labor": "عمالي",
  "client.claimAmount": "قيمة المطالبة (بالجنيه)",
  "client.enterClaimAmount": "أدخل قيمة المطالبة",
  "client.calculateFees": "احسب الرسوم",
  "client.feeEstimate": "تقدير الرسوم القضائية",
  "client.registrationFee": "رسم القيد",
  "client.serviceFee": "رسم الخدمات",
  "client.totalFee": "الإجمالي",
  "client.feeDisclaimer": "* هذا تقدير تقريبي وقد تختلف الرسوم الفعلية",
  "client.legalTemplatesTitle": "نماذج قانونية جاهزة",
  "client.templatesHint": "اختر النموذج المطلوب للتواصل وطلب النسخة",
  "client.satisfiedClients": "عميل راضٍ",
  "client.successfulCases": "قضية ناجحة",
  "client.yearsExperience": "سنة خبرة",
  "client.successRate": "نسبة النجاح",
  "client.clientReviews": "آراء عملائنا",
  "client.whatClientsSay": "ماذا يقول عملاؤنا عن خدماتنا",
  "client.ctaTitle": "هل لديك استفسار قانوني؟",
  "client.ctaDesc": "فريقنا من المحامين المتخصصين جاهز لمساعدتك. احجز استشارتك الآن واحصل على الدعم القانوني الذي تحتاجه.",
  "client.startNow": "ابدأ الآن",
  "client.needHelp": "تحتاج مساعدة؟ تواصل معنا",
  "client.footerBrandDesc": "منصة قانونية ذكية تقدم خدمات استشارية متكاملة بأحدث تقنيات الذكاء الاصطناعي.",
  "client.footerQuickLinks": "روابط سريعة",
  "client.bookConsultationLink": "حجز استشارة",
  "client.feeCalcLink": "حاسبة الرسوم",
  "client.templatesLink": "نماذج قانونية",
  "client.caseTrackerLink": "متابعة القضايا",
  "client.footerServices": "خدماتنا",
  "client.legalConsultations": "استشارات قانونية",
  "client.civilCommercial": "قضايا مدنية وتجارية",
  "client.familyPersonal": "قضايا أسرة وأحوال شخصية",
  "client.contractsDocs": "عقود وتوثيقات",
  "client.footerContact": "تواصل معنا",
  "client.location": "القاهرة، مصر",
  "client.allRights": "جميع الحقوق محفوظة",

  // Legal Templates
  "template.rentalContract": "عقد إيجار",
  "template.rentalContractDesc": "نموذج عقد إيجار سكني / تجاري شامل",
  "template.saleContract": "عقد بيع عقار",
  "template.saleContractDesc": "نموذج عقد بيع ابتدائي مع كافة الضمانات",
  "template.criminalComplaint": "شكوى جنائية",
  "template.criminalComplaintDesc": "نموذج بلاغ / شكوى للنيابة العامة",
  "template.officialNotice": "إنذار رسمي",
  "template.officialNoticeDesc": "نموذج إنذار على يد محضر",
  "template.specialPOA": "توكيل خاص",
  "template.specialPOADesc": "نموذج توكيل خاص بالتقاضي",
  "template.employmentContract": "عقد عمل",
  "template.employmentContractDesc": "نموذج عقد عمل محدد / غير محدد المدة",
  "template.defenseMemo": "مذكرة دفاع",
  "template.defenseMemoDesc": "نموذج مذكرة دفاع في قضية مدنية",
  "template.appealRequest": "طلب استئناف",
  "template.appealRequestDesc": "نموذج صحيفة طعن بالاستئناف",
  "template.contracts": "عقود",
  "template.complaints": "شكاوى",
  "template.notices": "إنذارات",
  "template.poa": "توكيلات",
  "template.memos": "مذكرات",
  "template.appeals": "طعون",

  // Student Page
  "student.legalLibrary": "المكتبة القانونية",
  "student.forStudents": "للطلاب والباحثين القانونيين",
  "student.switchMode": "تبديل الوضع",
  "student.back": "رجوع",
  "student.educationalPlatform": "منصة تعليمية للطلاب",
  "student.heroTitle1": "ابدأ رحلتك في عالم",
  "student.heroTitle2": "القانون والمحاماة",
  "student.heroDesc": "منصة تعليمية متكاملة تقدم لك الأبحاث والمحاضرات والموارد لتطوير مهاراتك القانونية وتحقيق التفوق الأكاديمي",
  "student.searchPlaceholder": "ابحث عن أبحاث، محاضرات، مصطلحات...",
  "student.filter": "فلترة",
  "student.all": "الكل",
  "student.civilLaw": "القانون المدني",
  "student.criminalLaw": "القانون الجنائي",
  "student.commercialLaw": "القانون التجاري",
  "student.laborLaw": "قانون العمل",
  "student.familyLaw": "قانون الأسرة",
  "student.research": "الأبحاث",
  "student.lectures": "المحاضرات",
  "student.resources": "الموارد",
  "student.researchTopics": "الأبحاث والموضوعات",
  "student.researchCount": "بحث",
  "student.readResearch": "قراءة البحث",
  "student.noResearch": "لا توجد أبحاث حالياً",
  "student.noResearchDesc": "سيتم إضافة الأبحاث والموضوعات القانونية قريباً. تابعنا للحصول على أحدث المحتوى التعليمي.",
  "student.videoLectures": "المحاضرات المرئية",
  "student.lectureCount": "محاضرة",
  "student.closeVideo": "إغلاق الفيديو",
  "student.watchLecture": "مشاهدة المحاضرة",
  "student.noLectures": "لا توجد محاضرات حالياً",
  "student.noLecturesDesc": "سيتم إضافة المحاضرات المرئية قريباً. يمكنك متابعة المنصة للحصول على أحدث الدروس والشروحات.",
  "student.legalSources": "مصادر ومراجع قانونية",
  "student.sourceCount": "مصدر",
  "student.visitSite": "زيارة الموقع",
  "student.noSources": "لا توجد مصادر حالياً",
  "student.noSourcesDesc": "سيتم إضافة المصادر والمراجع القانونية قريباً.",
  "student.goldenTips": "نصائح وإرشادات ذهبية",
  "student.goldenTipsDesc": "اكتسب مهارات عملية تفيدك في مسيرتك القانونية",
  "student.readMore": "اقرأ المزيد",
  "student.noTips": "لا توجد نصائح حالياً",
  "student.noTipsDesc": "سيتم إضافة النصائح والإرشادات القانونية قريباً لمساعدتك في مسيرتك الأكاديمية.",
  "student.postgrad": "تحضير الماجستير والدكتوراه",
  "student.postgradDesc": "أدوات ومصادر لمساعدتك في رحلتك الأكاديمية المتقدمة",
  "student.researchPlan": "إعداد خطة البحث",
  "student.researchPlanDesc": "تعلّم كيفية صياغة خطة بحث أكاديمية قوية تشمل المنهجية والإشكالية والفرضيات",
  "student.researchPlanItem1": "اختيار موضوع البحث وتحديد الإشكالية",
  "student.researchPlanItem2": "صياغة الفرضيات والأسئلة البحثية",
  "student.researchPlanItem3": "المنهج العلمي وأدوات البحث",
  "student.researchPlanItem4": "الإطار النظري والدراسات السابقة",
  "student.thesisWriting": "كتابة الرسائل العلمية",
  "student.thesisWritingDesc": "دليل شامل لكتابة رسالة الماجستير أو أطروحة الدكتوراه بالمعايير الأكاديمية",
  "student.thesisItem1": "هيكلة الرسالة العلمية وفصولها",
  "student.thesisItem2": "التوثيق والمراجع وفق APA / Chicago",
  "student.thesisItem3": "تحليل البيانات وعرض النتائج",
  "student.thesisItem4": "المناقشة والدفاع عن الرسالة",
  "student.legalSourceSearch": "البحث في المصادر القانونية",
  "student.legalSourceSearchDesc": "تعلّم أساليب البحث في قواعد البيانات والمكتبات القانونية المتخصصة",
  "student.sourceItem1": "استخدام قواعد البيانات القانونية",
  "student.sourceItem2": "البحث في الأحكام والتشريعات",
  "student.sourceItem3": "تحليل الاجتهاد القضائي",
  "student.sourceItem4": "المقارنة بين الأنظمة القانونية",
  "student.publishing": "النشر في المجلات العلمية",
  "student.publishingDesc": "خطوات وإرشادات لنشر أبحاثك في مجلات علمية محكّمة عربية ودولية",
  "student.publishItem1": "اختيار المجلة المناسبة للنشر",
  "student.publishItem2": "إعداد الورقة البحثية للنشر",
  "student.publishItem3": "التعامل مع ملاحظات المحكّمين",
  "student.publishItem4": "معايير الجودة والأصالة",
  "student.researchMethods": "مناهج البحث القانوني",
  "student.researchMethodsDesc": "استعراض المناهج العلمية المستخدمة في الدراسات القانونية المتقدمة",
  "student.methodItem1": "المنهج الوصفي والتحليلي",
  "student.methodItem2": "المنهج المقارن في القانون",
  "student.methodItem3": "المنهج التاريخي والاستقرائي",
  "student.methodItem4": "دراسة الحالة كأداة بحثية",
  "student.supervision": "الإشراف والمناقشة",
  "student.supervisionDesc": "نصائح للتعامل مع المشرف الأكاديمي والاستعداد لمناقشة الرسالة",
  "student.supervisionItem1": "اختيار المشرف المناسب",
  "student.supervisionItem2": "التواصل الفعّال مع المشرف",
  "student.supervisionItem3": "تحضير عرض المناقشة",
  "student.supervisionItem4": "الرد على أسئلة لجنة المناقشة",
  "student.footerRights": "جميع الحقوق محفوظة © 2026 - منصة تعليمية للطلاب والباحثين القانونيين",
  "student.content": "المحتوى",
  "student.keyPoints": "النقاط الرئيسية",
  "student.close": "إغلاق",
  "student.saveForLater": "حفظ للقراءة لاحقاً",
  "student.details": "التفاصيل",
  "student.benefits": "الفوائد",
  "student.beginner": "مبتدئ",
  "student.intermediate": "متوسط",
  "student.advanced": "متقدم",
  "student.live": "مباشر",
  "student.website": "موقع",
  "student.library": "مكتبة",
  "student.database": "قاعدة بيانات",
  "student.journal": "مجلة",

  // Testimonials
  "testimonial.name1": "أحمد محمد",
  "testimonial.role1": "رجل أعمال",
  "testimonial.content1": "تعاملت مع المكتب في قضية تجارية معقدة وكانت النتيجة ممتازة. أنصح بهم بشدة.",
  "testimonial.name2": "سارة العلي",
  "testimonial.role2": "مديرة شركة",
  "testimonial.content2": "خدمة احترافية ومتابعة مستمرة. شكراً للفريق على الجهود المبذولة.",
  "testimonial.name3": "خالد السعيد",
  "testimonial.role3": "مستثمر",
  "testimonial.content3": "المكتب الوحيد الذي أثق به في جميع شؤوني القانونية. خبرة وكفاءة عالية.",

  // Privacy Policy
  "privacy.title": "سياسة الخصوصية",
  "privacy.lastUpdated": "آخر تحديث: يونيو 2026",
  "privacy.intro": "نحن في Legal AI نلتزم بحماية خصوصيتك وأمان بياناتك. توضح هذه السياسة كيفية جمع واستخدام وحماية المعلومات الشخصية التي تقدمها لنا عند استخدام منصتنا.",
  "privacy.dataCollection": "المعلومات التي نجمعها",
  "privacy.dataCollection1": "معلومات الحساب: الاسم، البريد الإلكتروني، رقم الهاتف، وكلمة المرور.",
  "privacy.dataCollection2": "معلومات المكتب: اسم المكتب القانوني، التخصصات، والموقع الجغرافي.",
  "privacy.dataCollection3": "بيانات الاستخدام: سجلات الجلسات والمهام والقضايا التي تديرها عبر المنصة.",
  "privacy.dataUse": "كيف نستخدم معلوماتك",
  "privacy.dataUse1": "توفير خدمات إدارة المكتب القانوني والموكلين والقضايا.",
  "privacy.dataUse2": "إرسال تنبيهات وتذكيرات بالجلسات والمواعيد القانونية.",
  "privacy.dataUse3": "تحسين تجربة المستخدم وتطوير خدمات الذكاء الاصطناعي القانوني.",
  "privacy.dataProtection": "حماية البيانات",
  "privacy.dataProtection1": "نستخدم تقنيات تشفير متقدمة (SSL/TLS) لحماية نقل البيانات.",
  "privacy.dataProtection2": "يتم تخزين البيانات على خوادم آمنة مع إجراءات وصول مشددة.",
  "privacy.dataProtection3": "نطبق سياسات أمان صارمة لمنع الوصول غير المصرح به.",
  "privacy.userRights": "حقوقك",
  "privacy.userRights1": "الحق في الوصول إلى بياناتك الشخصية وتصحيحها.",
  "privacy.userRights2": "الحق في طلب حذف حسابك وبياناتك بالكامل.",
  "privacy.userRights3": "الحق في الاعتراض على معالجة بياناتك لأغراض تسويقية.",
  "privacy.cookies": "ملفات تعريف الارتباط (Cookies)",
  "privacy.cookies1": "نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح وتذكر تفضيلاتك.",
  "privacy.cookies2": "يمكنك تعطيل ملفات تعريف الارتباط من إعدادات المتصفح في أي وقت.",
  "privacy.thirdParty": "مشاركة البيانات مع طرف ثالث",
  "privacy.thirdParty1": "لا نبيع أو نشارك بياناتك الشخصية مع أي طرف ثالث لأغراض تجارية.",
  "privacy.thirdParty2": "قد نشارك البيانات فقط مع مزودي الخدمات الأساسيين مثل خوادم التخزين والإشعارات.",
  "privacy.retention": "الاحتفاظ بالبيانات",
  "privacy.retention1": "نحتفظ ببياناتك طالما كان حسابك نشطاً أو حسبما يقتضي القانون المصري.",
  "privacy.retention2": "عند حذف الحساب، يتم حذف البيانات الشخصية خلال 30 يوماً بحد أقصى.",
  "privacy.changes": "التعديلات على السياسة",
  "privacy.changes1": "قد نقوم بتحديث سياسة الخصوصية من وقت لآخر.",
  "privacy.changes2": "سيتم إخطارك بأي تغييرات جوهرية عبر البريد الإلكتروني أو إشعار داخل التطبيق.",
  "privacy.phone": "الهاتف",
};
